module.exports = __webpack_public_path__ + "static/img/190.594b16c.png";